import EmployerRouteListConfig from '../../app/employer/routes';
import adminRouteList from '../../app/admin/routes';
import adminDeveloperRouteList from '../../app/admin/developer/routes';
import tempRouteList from '../../app/temp/routes';
import impersonationRouteList from '../../app/impersonation/routes';

import getIsPageReadyWithAppEnvByURLPath from '../../constants/pageEnvironmentAccess';
import authRouteList from '../authRoutes';
import { isEnvironmentProduction } from '../../env/env';
import partnerRouteList from './partnerRouteList';

const tempRoutesInclude = () => {
   if (!isEnvironmentProduction()) {
      return tempRouteList;
   }
   return [];
};

const allRouteList = [
   ...EmployerRouteListConfig,
   ...adminRouteList,
   ...authRouteList,
   ...adminDeveloperRouteList,
   ...impersonationRouteList,
   ...partnerRouteList,
   // ONLY developers samples... should NEVER go to production
   ...tempRoutesInclude(),
];

export default allRouteList.filter((route) => getIsPageReadyWithAppEnvByURLPath(route.path));
